import React, { useState, useEffect } from 'react';
import Header from '../../components/partials/Header';
import { Container, Navbar } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import '../../styles/login.css';
import { connect } from 'react-redux';
import axios from 'axios';

function Forgot(props) {
  const [email, setEmail] = useState('');
  const [showModal, setShowModal] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleSubmit = event => {
    event.preventDefault();

    let user = {
      email: email,
    };

    axios
      .post('https://emaildrop.com/forgot', { user }, {})
      .then(response => {
        setShowModal(true);
      })
      .catch(error => console.log('api errors:', error));
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <div>
      <Container
        fluid
        className="form-container d-flex justify-content-center align-items-center"
      >
        <Form
          className="login-form shadow p-3 bg-white rounded"
          onSubmit={handleSubmit}
        >
          <h2 className="mb-3">Forgot Password</h2>

          <Form.Group className="mb-3" controlId="formName">
            <Form.Label>Enter Your Email Address</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Email"
              onChange={e => setEmail(e.target.value)}
              value={email}
              name="email"
            />
          </Form.Group>
          <Button className="formButton" type="submit">
            Reset
          </Button>
        </Form>
      </Container>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Request Submitted</Modal.Title>
        </Modal.Header>
        <Modal.Body>A password reset email was sent to {email}</Modal.Body>
      </Modal>
    </div>
  );
}
export default connect()(Forgot);
